var _a;
import { Document_Content_Type } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[Document_Content_Type.Image] = 'Image',
    _a[Document_Content_Type.Other] = 'Other',
    _a[Document_Content_Type.Pdf] = 'PDF',
    _a);
export var DocumentContentTypeEnum = {
    name: 'Document_Content_Type',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
